export default __webpack_public_path__ + "static/075-49f7da9b740fa6a4b435e3f73786e38a.jpg";